import pkg from './package.json';

/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
__webpack_public_path__ = `${pkg.version}/`;

export default {
  start: () => {
  },
};

